import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IOffer } from '@boma/website/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  createEntity(
    type: string,
    name: string,
    locationName: string,
    coordinates: any,
    openingTime: string,
    closingTime: string,
    notificationEmailAddress: string,
    contactPersonName: string,
    contactPersonNumber: string
  ) {
    let payload = {
      name,
      type,
      location: {
        name: locationName,
        closingTime,
        openingTime,
        contactPersonName,
        contactPersonNumber,
        notificationEmailAddress,
        point: {
          coordinates,
        },
      },
    };

    return this.httpClient.post<any>(
      `${this.base}api/v${this.version}/Entities`,
      payload
    );
  }
}
